@if (documentsAwaitingReadReceipt() ?? []; as documentsAwaitingReadReceipt) {
  @if (documentsAwaitingReadReceipt.length > 0) {
    <div class="document-read-receipts-section">
      <div class="document-read-receipts-header">
        <div class="title-group">
          <h3>{{ 'documentsAwaitingReadReceipt' | translate }}</h3>
          <app-ui-pill [customLabel]="true" name="paused">
            {{ documentsAwaitingReadReceipt.length }}
          </app-ui-pill>
        </div>
      </div>

      <div class="document-read-receipts-table">
        <app-main-table
          class="thin-rows"
          [loading]="(loadingActions | actionInProgress: true | async) === true"
          [tableData]="documentsAwaitingReadReceipt | slice: 0 : visibleDocumentsCount"
          [displayedColumns]="displayedColumns"
          [disabledColumnHeaders]="displayedColumns"
          [columnTitlesMap]="columnTitlesMap"
          [searchingEnabled]="false"
          [filteringEnabled]="false"
          [sortingEnabled]="false"
          [paginationEnabled]="false"
          [elevationEnabled]="false"
          [hasRoutingForRow]="false"
          (rowHandler)="openDocumentAwaitingReadReceipt($event)"
          viewMode="embedded"
        ></app-main-table>

        @if (documentsAwaitingReadReceipt.length > visibleDocumentsCount) {
          <div class="show-more-row" (click)="onShowMoreDocumentsAwaitingReadReceipt()">
            {{ 'showMore' | translate }}
          </div>
        }
      </div>
    </div>
  }
}
